import React from "react";
import "../../assets/css/top.css";
import { Link } from "react-scroll";
import MailOutlineIcon from "@material-ui/icons/MailOutline";

const TopArea = (props) => {
  return (
    <section className="top-container cover" id={props.id}>
      <div className="top-container--back">
        <div className="top-container--inner yu-gothic center-box center front">
          <div className="grid__row--around">
            <div>
              <div className="canpany-title text-white">RAYWARD.Inc</div>
              <div className="product-title text-white">- ShinGan -</div>
              <div className="spacer-box--ss" />
              <div className="top-text text-white">
                作品を守り、価値を最大限に
              </div>
            </div>
            <div>
              <Link
                to="contact"
                spy={true}
                smooth={true}
                offset={-70}
                duration={500}
              >
                <div className="top-contact-button">
                  <div className="flex-row">
                    <div className="btn-style--icon">
                      <MailOutlineIcon />
                    </div>
                    <div className="btn-style--text">問い合わせ</div>
                  </div>
                </div>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
export default TopArea;
